/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { ScopeQuestionGroupOptionalValue } from '../../types/survey';
import { ScopeQuestionOptionalValue } from '../../types/surveyScope';
import { safeColours } from '../form/partials/ColourPickerPopup';
import { Column, TrackingList } from '../tracking-list';
import Row from '../tracking-list/row';
import { GroupHeaderColumn } from './types';
import { QUESTION } from '../../constants/terminology';

export interface GroupTitleProps {
  isOpen: boolean;
  toggle?: () => void;
  questionList: ScopeQuestionOptionalValue[];
  questionGroup: ScopeQuestionGroupOptionalValue;
  headerColumns: GroupHeaderColumn[];
}

export const SurveyGroupTitle = (props: GroupTitleProps) => {
  const { toggle, isOpen, questionList, questionGroup } = props;
  const headerColumns = props.headerColumns ?? [];
  const columnProps = {
    questionList,
    questionGroup,
  }
  const hasQuestions = questionList && questionList.length > 0;
  const icon = !hasQuestions ? '' : isOpen ? 'fa-chevron-down' : 'fa-chevron-right';
  const colour = questionGroup.groupData && questionGroup.groupData.colour;

  const isSafeColour = !colour || safeColours.includes(colour);
  const onClick = toggle && hasQuestions ? () => toggle() : undefined;

  const style = colour ? { backgroundColor: colour, borderColor: colour } : undefined;
  const isScopeView = Boolean(questionGroup.count);

  if (isScopeView) {
    return (
      <Row className='scopeGroupTitle'>
        <Column className='h4 scopeGroupName'>{questionGroup.groupName}</Column>
        <Column>{`${questionGroup.count} ${QUESTION.SINGULAR}${questionGroup.count === 1 ? '' : 's'}`}</Column>
      </Row>
    );
  }

  return (
    <TrackingList className={'questionListGroup mb-1'}>
      <Row
        onClick={onClick}
        style={style}
        className={!isSafeColour ? 'text-ThemeTextWhite' : ''}
      >
        {toggle ? (
          <Column>
            <i className={`ml-2 fa ${icon}`} />
          </Column>
        ) : (
          <Column className='px-1' />
        )}
        <Column stretch truncate>
          {questionGroup.groupName}
        </Column>
        <Column className='statsCol'>{questionGroup.count ?? questionList.length}</Column>
        {headerColumns.map((element, index) =>
          React.createElement(element, {
            ...columnProps,
            key: `group-col-${index}-${questionGroup.groupCode}`,
          })
        )}
      </Row>
    </TrackingList>
  );
};
